import { render, staticRenderFns } from "./Chat.component.vue?vue&type=template&id=205568f4&scoped=true"
import script from "./Chat.component.vue?vue&type=script&lang=js"
export * from "./Chat.component.vue?vue&type=script&lang=js"
import style0 from "./Chat.component.vue?vue&type=style&index=0&id=205568f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205568f4",
  null
  
)

export default component.exports